// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".illustrationWrapper--Pu7JIhry {\n  width: 100%;\n  height: 100%;\n  background-color: transparent;\n  text-align: center;\n}\n\n.header--3jxNr95f {\n  padding-bottom: 20px;\n}\n.title--1FVzO_zQ {\n  color: var(--color-header-text);\n  font-size: 20px;\n  font-weight: 500;\n  line-height: 26px;\n}\n\n.description--11EPsoAu {\n  padding-top: 20px;\n  font-weight: 400;\n  color: var(--color-auxiliary-text);\n  line-height: 20px;\n}\n\n.footer--f0a8Xjcm {\n  padding-top: 20px;\n}\n.feedback--11GKENL3 {\n  padding-top: 52px;\n}\n.text--3VtBpAvr {\n  color: var(--color-secondary-text);\n}\n.guide--egnAp2pJ {\n  padding-top: 152px;\n}\n\n@media (max-width: 1440px) {\n    .illustrationWrapper--Pu7JIhry img {\n      width: 240px;\n    }\n}\n\n@media (min-width: 1440px) {\n    .illustrationWrapper--Pu7JIhry img {\n      width: 300px;\n    }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"illustrationWrapper": "illustrationWrapper--Pu7JIhry",
	"header": "header--3jxNr95f",
	"title": "title--1FVzO_zQ",
	"description": "description--11EPsoAu",
	"footer": "footer--f0a8Xjcm",
	"feedback": "feedback--11GKENL3",
	"text": "text--3VtBpAvr",
	"guide": "guide--egnAp2pJ"
};
export default ___CSS_LOADER_EXPORT___;
